import { WebpHeaderImage } from "../assets";

let megaMenuList = [
  {
    title: "Refrigerator Repair",
    link: "#",
    children: [
    {
      title: "Refrigerator Repairs",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Freezer Repair",
      titleLink: "#",
      img: WebpHeaderImage,   contentLink: "#",
        content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
    },
    {
      title: "Washer Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Dryer Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
     
    ],
  },
 
  {
    title: "Oven Repair",
    link: "#",
    children: [
    {
      title: "Oven Repairs",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Stove Repair",
      titleLink: "#",
      img: WebpHeaderImage,
        content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
    },
    {
      title: "Range Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Cooktop Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
  
  
     
    ],
  },
  {
    title: "Dishwasher Repair",
    link: "#",
    children: [
    {
      title: "Dishwasher Repairs",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Garbage Disposal Repair",
      titleLink: "#",
      img: WebpHeaderImage,
        content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
    },
    {
      title: "Microwave Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Trash Compactor Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
  
  
     
    ],
  },
  {
    title: "HVAC Repair",
    link: "#",
    children: [
    {
      title: "HVAC Repairs",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Air Conditioning Repair",
      titleLink: "#",
      img: WebpHeaderImage,
        content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
    },
    {
      title: "Heating Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
    {
      title: "Furnace Repair",
      titleLink: "#",
      img: WebpHeaderImage,
      content: "At Same Day Appliance Repair, we are a family-owned business committed to enhancing your customer experience. We understand the frustration of appliance repairs, and we pride ourselves on our transparency and reliability. This page is designed to give you a thorough understanding of our pricing policies, the costs associated with freezer repairs, and our unique approach to service.",
      contentLink: "#",
    },
  
  
     
    ],
  },
];

export { megaMenuList };
